<template><div><h1 id="paynet-transaktionen" tabindex="-1"><a class="header-anchor" href="#paynet-transaktionen"><span>Paynet Transaktionen</span></a></h1>
<p>Paynet Transaktionen — Status der Paynet Transaktionen im System</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Paynet Transaktionen zeigen die vom System ausgeführten Transaktionen.</p>
<p>Pfad:</p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>ID</dt>
<dd>Die <span class="emphasis"><em><span class="application">funtrade</span></em></span> Transaktions-Nummer.</dd>
<dt>Personen-ID</dt>
<dd>Refernziert den Empfänger der E-Rechnung.</dd>
<dt>Quelle</dt>
<dd>Eine kurze Kennzeichnung, aus welchem Geschäftsprozess die Transaktion entstanden ist. FAKT = Rechnung aus dem Verkauf, MAHN = Mahnung, ZUSF = Zusagenfakturierung.</dd>
<dt>Status</dt>
<dd>Uebermittelt oder Fehlerhaft. Der Status bezieht sich nur auf die Übermittlung zu Paynet. Wenn die E-Rechnung inhaltliche Fehler hat, wird das erst später von SIX-Paynet per E-Mail gemeldet.</dd>
<dt>Details</dt>
<dd>Hier schreibt das System Details zur Übertrag rein. Man kann das Feld auch manuell beschreiben und bei problematischen Transaktionen zum Beispiel notieren, welche Schritte unternommen wurden.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Falls die Übermittlung zu SIX-Paynet nicht erfolgreich war, kann hier eine Transaktion (oder alle noch nicht übermittelten Transaktionen) erneut geschickt werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/backend_integration.html#paynet">E-Rechnung mit Paynet</RouteLink></p>
</div></template>


